import { Component, Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './detailed-view.component.ajs';

@Directive({
  selector: 'cng-hypervision-detailed-upgrade',
})
export class HypervisionDetailedUpgradeComponent extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-hypervision-detailed',
  template: '<cng-hypervision-detailed-upgrade></cng-hypervision-detailed-upgrade>',
})
export class HypervisionDetailedComponent {}
